import {
  IsArray,
  IsBoolean,
  IsDate,
  IsIn,
  IsInt,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  ValidateNested,
} from "class-validator";
import { Type } from "class-transformer";

import { Constants } from "@eagerdog/constants";

import { AddressDto } from "../common";
import { SessionDto } from "./session.dto";

export class CourseDto {
  //
  @IsOptional()
  club_name?: string;

  @IsNotEmpty()
  title: string = "";

  @IsOptional()
  description?: string;

  @IsOptional()
  notes?: string;

  // @IsNotEmpty()
  // @IsIn(Object.values(Constants.sanctioning_club))
  // sanctioning_club: string;

  @IsNotEmpty()
  conditions: string = ""; //Indoor, Outdoor, Indoor & Outdoor

  @IsOptional()
  @IsIn(Object.values(Constants.course_type))
  course_type?: string;

  //start_date?: Date; // calculated from the sessions
  //end_date?: Date;

  @ValidateNested()
  @Type(() => AddressDto)
  address: AddressDto;

  @IsOptional()
  timezone?: string;

  @IsOptional()
  @IsIn(Object.values(Constants.course_status))
  status?: string;

  @IsOptional()
  @IsDate()
  publish_at?: Date;

  @IsOptional()
  @IsDate()
  registration_end_date?: Date;

  @IsOptional()
  registration_message?: string;

  @IsOptional()
  waiver?: string;

  @IsOptional()
  club_policies?: string;

  // Course sessions
  @ValidateNested()
  @Type(() => SessionDto)
  schedule: SessionDto[];

  @IsNotEmpty()
  @IsNumber()
  fee: number;

  @IsBoolean()
  use_early_bird_fee: boolean;

  @IsOptional()
  @IsNumber()
  early_bird_fee?: number;

  @IsOptional()
  @IsDate()
  early_bird_end_date?: Date;

  @IsOptional()
  @IsInt()
  max_dogs?: number;

  //waitlist_option?: string; //Constants.waitlist_options

  /**
   * It is used for two waitlist_options:
   * Constants.waitlist_options.daily_judge_time_limit - to store the number of judge's hours per day (optional, default 8)
   * Constants.waitlist_options.show_entry_limit = max number of entries per show
   */
  @IsOptional()
  @IsNumber()
  waitlist_limit?: number;

  /**
   * Enable waitlist when the waitlist_limit is reached (for Show Entry Limit and Daily Judge Time Limit)
   */
  @IsOptional()
  @IsBoolean()
  waitlist_enabled?: boolean;

  /**
   * Size of the waitlist (for Show Entry Limit and Daily Judge Time Limit)
   */
  @IsOptional()
  @IsNumber()
  waitlist_size?: number;

  @IsOptional()
  @IsArray()
  attachments?: string[];

  @IsOptional()
  @IsIn(Object.values(Constants.course_category))
  category?: string;
}
